import React from "react";
import "./bottomNav.scss";

function BottomNavItem(props) {
  const { iconUrl, title, iconAlt, onClick } = props;
  return (
    <div
      className="bottom-nav-item"
      onClick={() => {
        window.analytics.track("bottomNav.click", {
          title
        });
        onClick && onClick();
      }}
    >
      <img src={iconUrl} alt={iconAlt} />
      <div className="title">{title}</div>
    </div>
  );
}

function BottomNav(props) {
  return <div className="bottom-nav">{props.children}</div>;
}

export { BottomNav, BottomNavItem };
